import { render } from "./PasswordConfirmModal.vue?vue&type=template&id=d23101e6"
import script from "./PasswordConfirmModal.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PasswordConfirmModal.vue"]])

export default __exports__